import { FULL_HEART, FULL_HUNGER, POTION, SCROLL } from "../../tiles";
import Colors from "../Colors";

export const consumables = {
  healingPotion: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PURPLE_3,
      ch: POTION,
    },
    text: {
      name: `${POTION} Health`,
      description: `Lose 2${FULL_HUNGER}, restore ${FULL_HEART}`,
    },
    use: {
      advancesTurn: true,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [
            { stat: "health", type: "gain", amount: 1 },
            { stat: "hunger", type: "lose", amount: 2 },
          ],
        },
      ],
    },
  },
  rejuvPotion: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PURPLE_3,
      ch: POTION,
    },
    text: {
      name: `${POTION} Revitalize`,
      description: `Restore ${FULL_HEART}`,
    },
    use: {
      advancesTurn: true,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [{ stat: "health", type: "gain", amount: 1 }],
        },
      ],
    },
  },
  staminaPotion: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PURPLE_3,
      ch: POTION,
    },
    text: {
      name: `${POTION} Stamina`,
      description: `Restore 3${FULL_HUNGER}`,
    },
    use: {
      advancesTurn: true,
      target: {
        type: "self",
      },
      effects: [
        {
          statAdjustments: [{ stat: "hunger", type: "gain", amount: 3 }],
        },
      ],
    },
  },
  scrollFreedom: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PEACH_1,
      ch: SCROLL,
    },
    text: {
      name: `${SCROLL} Freedom`,
      description:
        "You may place your letters anywhere this turn. You will not gain any new letters.",
    },
    use: "freeEntry",
  },
  potionLettersMinor: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PURPLE_3,
      ch: POTION,
    },
    text: {
      name: `${POTION} Vocab`,
      description: "Add 2 letters to your wand.",
    },
    use: "lettersTwo",
  },
  potionLettersMajor: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PURPLE_3,
      ch: POTION,
    },
    text: {
      name: `${POTION} Dictionary`,
      description: "Add 4 letters to your wand, but takes a moment.",
    },
    advancesTurn: true,
    use: "lettersChug",
  },
  potionSpells: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PURPLE_3,
      ch: POTION,
    },
    text: {
      name: `${POTION} Mana`,
      description: "Recharge one use for each spell",
    },
    advancesTurn: true,
    use: "spellMinor",
  },
  scrollPoly: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PEACH_1,
      ch: SCROLL,
    },
    text: {
      name: `${SCROLL} Polymorph`,
      description: "Turn yourself into a new word",
    },
    use: "simplePoly",
  },
  scrollMorph: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PEACH_1,
      ch: SCROLL,
    },
    text: {
      name: `${SCROLL} Morph`,
      description: "Turn target into a new word",
    },
    use: "targetPoly",
  },
  scrollWeaken: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PEACH_1,
      ch: SCROLL,
    },
    text: {
      name: `${SCROLL} Restrict`,
      description: "Removes a word option from the enemy",
    },
    use: "weaken",
  },
  scrollHinder: {
    displayPriority: 15,
    glyph: {
      fg: Colors.PEACH_1,
      ch: SCROLL,
    },
    text: {
      name: `${SCROLL} Enfeeble`,
      description: "Removes a word option from the enemy",
    },
    use: "hinder",
  },
} as const;
